"use client";

import { LIVE_STATUSES } from "@/contants";
import { useFilterOdds } from "@/hooks/useFilterOdds";
import { useLiveDataForMatch } from "@/hooks/useLiveData";
import { useMatchData } from "@/hooks/useMatchData";
import { useMatchOdds } from "@/hooks/useMatchOdds";
import { formatUnixToVNDate } from "@/utils/format";
import { getMatchDisplayTime } from "@/utils/matchInfo";
import { getHandicapInfo } from "@/utils/odds";
import flashImage from "@/assets/images/flash.gif";

const ROW_H = "1.15em";
const TIME_W = "2.75rem";
const TEAM_W = "6.5rem";
const ODDS_LABEL_W = "1.5rem";
const ODDS_VAL_W = "2.25rem";
const ODDS_1X2_W = "2.25rem";
const gridRows = `${ROW_H} ${ROW_H} ${ROW_H}`;
const fontClass = "text-[11px] md:text-[13px]";
const oddsCell = (content, align = "right", green = false, width = ODDS_VAL_W) => (
  <div
    className={`flex items-center h-full px-0.5 font-semibold ${fontClass} ${green ? "text-emerald-600" : "text-[var(--theme-text)]"} ${align === "center" ? "justify-center" : "justify-end"}`}
    style={{ minWidth: width, maxWidth: width }}
  >
    <span className={`block w-full overflow-visible whitespace-nowrap ${align === "center" ? "text-center" : "text-right"}`}>{content}</span>
  </div>
);
const oddsLabel = (content, green = false) => oddsCell(content, "center", green, ODDS_LABEL_W);

function oddVal(instant, initial) {
  const v = instant ?? initial;
  return v != null && v !== "" ? String(v) : "";
}

export default function AfinaMatch({ match, index }) {
  if (!match) return null;

  const { gio: formattedGio, date: formattedDate } = formatUnixToVNDate(match.matchTime ?? 0);
  // const handicapHalf = match.handicapHalfOdds?.[0];
  // const overUnderHalf = match.overUnderHalfOdds?.[0];
  // const europeHalf = match.europeHalfOdds?.[0];

  const { getScore, getOdds } = useLiveDataForMatch(match.id);
  const liveScore = getScore();
  const liveOdds = getOdds();

  // Filter odds với companyId = -1 (tất cả)
  const filterOdds = useFilterOdds(match, liveOdds, null, -1);
  // Lấy tất cả odds từ useMatchOdds
  const odds = useMatchOdds(match, filterOdds, -1);
  const { currentHomeScore, currentAwayScore } = useMatchData(liveScore, match);

  const handicapVal = odds.handicapValue;
  const homeHandicap = odds.homeHandicapOdds;
  const awayHandicap = odds.awayHandicapOdds;

  // Kiểm tra kèo trên/kèo dưới 
  const { homeIsFavorite, awayIsFavorite } = getHandicapInfo(handicapVal);
  const ouVal = odds.overUnderValue;
  const overOdds = odds.overOdds;
  const underOdds = odds.underOdds;

  const homeEurope = odds.homeEuropeOdds;
  const drawEurope = odds.instantDrawOdds;
  const awayEurope = odds.awayEuropeOdds;

  const statusNum = liveScore?.status !== undefined ? Number(liveScore.status) : Number(match.status);
  const isLive = LIVE_STATUSES.includes(statusNum);
  const displayTime = getMatchDisplayTime(liveScore, statusNum, match?.matchTime, match?.halfStartTime, true);
  
  const cell = (child, col, row, className = "") => (
    <div key={`${col}-${row}`} className={`${fontClass} ${className}`} style={{ gridColumn: col, gridRow: row }}>
      {child}
    </div>
  );
  const timeCell = (content, row) => cell(<span className="text-[#c2410c] font-medium text-center block w-full">{content}</span>, 1, row, "flex items-center justify-center min-w-[2.75rem]");
  const teamCell = (content, row, primary) => cell(
    <span className={`font-semibold truncate md:overflow-visible md:whitespace-normal md:break-words ${primary ? "text-[var(--theme-primary)]" : "text-[var(--theme-text)]"}`}>{content}</span>,
    2, row, "flex items-center min-w-0"
  );

  const timeLiveCell = (displayTime, match, currentHomeScore, currentAwayScore) => {
    return (
      <>
        {timeCell(`${currentHomeScore} - ${currentAwayScore}`, 1, homeIsFavorite)}
        {teamCell(match.homeName ?? "", 1, homeIsFavorite)}
        {timeCell((
          <div className="flex justify-center gap-1 items-center">
            <div className="m-0">
              <img src={flashImage} alt="live" className="w-2 h-2" />
            </div>
            <div className="m-0">
              {
                displayTime.type === 'minute' || displayTime.type === 'status' ? (
                  <>
                    { displayTime.content ?? displayTime.halfLabel}
                    <span style={{ animation: "blink 1s infinite" }}>&apos;</span>
                  </>
                ) : (
                  "VAR"
                )
              }
            </div>
          </div>
        ), 2)}
        {teamCell(match.awayName ?? "", 2, awayIsFavorite)}
      </>
    );    
  };
  
  return (
    <div
      className={` ${isLive ? "afina-match-live" : `afina-match-${index % 2 === 0 ? "even" : "odd"}`}  afina-match-row afina-match-row-grid pl-0.5 pr-3 py-1.5 gap-x-1.5 md:gap-x-4`}
      style={{
        display: "grid",
        gridTemplateRows: gridRows,
        alignItems: "center",
        rowGap: "0.35rem",
      }}
    >
      {isLive ? (
        <>
         {timeLiveCell(displayTime, match, currentHomeScore, currentAwayScore)}
        </>
      ): 
      (
        <>
          {timeCell(formattedGio, 1)}
          {teamCell(match.homeName ?? "", 1, homeIsFavorite)}
          {timeCell(formattedDate, 2)}
          {teamCell(match.awayName ?? "", 2, awayIsFavorite)}
        </>
      )}
      
    
   
      {cell(null, 1, 3, "flex items-center")}
      {cell(null, 2, 3, "flex items-center")}

      {cell(oddsLabel(handicapVal || "0", true), 4, 1)}
      {cell(oddsCell(homeHandicap), 5, 1)}
      {cell(oddsLabel(ouVal || "2.5", true), 6, 1, "flex items-center border-l border-white/40 pl-1")}
      {cell(oddsCell(overOdds), 7, 1)}
      {cell(oddsCell(homeEurope, "right", false, ODDS_1X2_W), 8, 1, "flex items-center border-l border-white/40 pl-1")}

      {cell(oddsLabel(""), 4, 2)}
      {cell(oddsCell(awayHandicap), 5, 2)}
      {cell(oddsLabel("u"), 6, 2, "flex items-center border-l border-white/40 pl-1")}
      {cell(oddsCell(underOdds), 7, 2)}
      {cell(oddsCell(drawEurope, "right", false, ODDS_1X2_W), 8, 2, "flex items-center border-l border-white/40 pl-1")}

      {cell(oddsLabel(""), 4, 3)}
      {cell(oddsCell(""), 5, 3)}
      {cell(oddsLabel(""), 6, 3, "flex items-center border-l border-white/40 pl-1")}
      {cell(oddsCell(""), 7, 3)}
      {cell(oddsCell(awayEurope, "right", false, ODDS_1X2_W), 8, 3, "flex items-center border-l border-white/40 pl-1")}
    </div>
  );
}
